import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    currentUserAndGroupsTab: null,
    userAndGroupSortList: false,
    userAndGroupQuery: ''
  },
  getters: {
    currentUserAndGroupsTab: (state) => {
      return state.currentUserAndGroupsTab;
    },
    getUserAndGroupsQuery: (state) => {
      return state.userAndGroupQuery;
    },
    getUserAndGroupSortList: (state) => {
      return state.userAndGroupSortList;
    },
  },
  mutations: {
    SAVE_CURRENT_USERS_GROUPS_TAB(state, payload) {
      state.currentUserAndGroupsTab = payload;
    },
    SAVE_USERS_GROUPS_QUERY(state, payload) {
      state.userAndGroupQuery = payload;
    },
    SAVE_USERS_GROUPS_SORTLIST(state, payload) {
      state.userAndGroupSortList = payload;
    },
  },
  actions: {
    setCurrentUsersAndGroupTab({ commit }, payload) {
      commit("SAVE_CURRENT_USERS_GROUPS_TAB", payload);
    },
    setUsersAndGroupQuery({ commit }, payload) {
      commit("SAVE_USERS_GROUPS_QUERY", payload);
    },
    setUsersAndGroupSortList({ commit }, payload) {
      commit("SAVE_USERS_GROUPS_SORTLIST", payload);
    },
  },
};
